webpackJsonp([100],{

/***/ 10:
/***/ (function(module, exports, __webpack_require__) {

var map = {
	"./en/hotel.json": [
		115,
		10
	],
	"./ja/hotel.json": [
		116,
		9
	],
	"./ko/hotel.json": [
		117,
		8
	],
	"./zh-CN/hotel.json": [
		118,
		7
	],
	"./zh-TW/hotel.json": [
		119,
		6
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return __webpack_require__.e(ids[1]).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
module.exports = webpackAsyncContext;
webpackAsyncContext.id = 10;

/***/ }),

/***/ 238:
/***/ (function(module, exports, __webpack_require__) {

"use strict";


__webpack_require__(493);

__webpack_require__(6);
__webpack_require__(5);

__webpack_require__(500);

/***/ }),

/***/ 268:
/***/ (function(module, exports, __webpack_require__) {

"use strict";
/* WEBPACK VAR INJECTION */(function($) {

var init = function () {
    var _ref = _asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee() {
        var slider, App, OwlCarousel;
        return regeneratorRuntime.wrap(function _callee$(_context) {
            while (1) {
                switch (_context.prev = _context.next) {
                    case 0:
                        _context.next = 2;
                        return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 8));

                    case 2:
                        _context.next = 4;
                        return __webpack_require__.e/* import() */(86).then(__webpack_require__.bind(null, 192));

                    case 4:
                        _context.next = 6;
                        return __webpack_require__.e/* import() */(3).then(__webpack_require__.bind(null, 20));

                    case 6:
                        _context.next = 8;
                        return __webpack_require__.e/* import() */(1).then(__webpack_require__.bind(null, 12));

                    case 8:
                        _context.next = 10;
                        return __webpack_require__.e/* import() */(87).then(__webpack_require__.bind(null, 191));

                    case 10:
                        _context.next = 12;
                        return __webpack_require__.e/* import() */(91).then(__webpack_require__.bind(null, 255));

                    case 12:
                        if (hasMasterSlider === 'true') {
                            slider = new MasterSlider();

                            slider.setup('masterslider', {
                                width: 1650, // slider standard width
                                height: 600, // slider standard height
                                fullwidth: true,
                                view: "parallaxMask",
                                autoplay: true
                            });
                            slider.control('arrows');
                            slider.control('bullets');
                            slider.control('thumblist', { autohide: false, dir: "v" });
                        }

                        _context.next = 15;
                        return __webpack_require__.e/* import() */(4).then(__webpack_require__.bind(null, 19));

                    case 15:
                        App = _context.sent;
                        _context.next = 18;
                        return __webpack_require__.e/* import() */(2).then(__webpack_require__.bind(null, 11));

                    case 18:
                        OwlCarousel = _context.sent;

                        $(document).ready(function () {
                            App.init();
                            App.initParallaxBg();
                            App.initAnimateDropdown();
                            OwlCarousel.initOwlCarousel();
                        });

                        $(function () {
                            var winh = $(window).height();
                            var winh_pic = winh - 157;
                            $('.index_pic1').css('height', winh_pic);
                            $('.index_pic2, .index_pic3, .index_pic4').css('height', winh_pic / 2);
                            // var winw = $(window).width();
                            // $('.sprow').css('width',winw);

                            $('.index_pic1, .index_pic2, .index_pic3, .index_pic4').mouseenter(function () {
                                $(this).addClass('in');
                            });
                            $('.index_pic1, .index_pic2, .index_pic3, .index_pic4').mouseleave(function () {
                                $('.index_pic1, .index_pic2, .index_pic3, .index_pic4').removeClass('in');
                            });
                        });

                    case 21:
                    case 'end':
                        return _context.stop();
                }
            }
        }, _callee, this);
    }));

    return function init() {
        return _ref.apply(this, arguments);
    };
}();

__webpack_require__(238);

function _asyncToGenerator(fn) { return function () { var gen = fn.apply(this, arguments); return new Promise(function (resolve, reject) { function step(key, arg) { try { var info = gen[key](arg); var value = info.value; } catch (error) { reject(error); return; } if (info.done) { resolve(value); } else { return Promise.resolve(value).then(function (value) { step("next", value); }, function (err) { step("throw", err); }); } } return step("next"); }); }; }

init().then(_asyncToGenerator( /*#__PURE__*/regeneratorRuntime.mark(function _callee2() {
    var parsley, text, Pikaday, pikaI18n, dateFieldFormat, checkInDate, checkOutDate, validator;
    return regeneratorRuntime.wrap(function _callee2$(_context2) {
        while (1) {
            switch (_context2.prev = _context2.next) {
                case 0:
                    _context2.next = 2;
                    return __webpack_require__.e/* import() */(5).then(__webpack_require__.bind(null, 23));

                case 2:
                    parsley = _context2.sent;
                    _context2.next = 5;
                    return __webpack_require__(10)("./" + locale + '/hotel.json');

                case 5:
                    text = _context2.sent;
                    _context2.next = 8;
                    return __webpack_require__.e/* import() */(89).then(__webpack_require__.bind(null, 501));

                case 8:
                    Pikaday = _context2.sent;
                    pikaI18n = {
                        'zh-TW': {
                            previousMonth: '上個月',
                            nextMonth: '下個月',
                            months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                            weekdays: ['週日', '週一', '週二', '週三', '週四', '週五', '週六'],
                            weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
                            dateFieldFormat: 'YYYY年 MM月 DD日'
                        },
                        'zh-CN': {
                            previousMonth: '上个月',
                            nextMonth: '下个月',
                            months: ['一月', '二月', '三月', '四月', '五月', '六月', '七月', '八月', '九月', '十月', '十一月', '十二月'],
                            weekdays: ['周日', '周一', '周二', '周三', '周四', '周五', '周六'],
                            weekdaysShort: ['日', '一', '二', '三', '四', '五', '六'],
                            dateFieldFormat: 'YYYY年 MM月 DD日'
                        },
                        'ja': {
                            previousMonth: '先月',
                            nextMonth: '来月',
                            months: ['1月', '2月', '3月', '4月', '5月', '6月', '7月', '8月', '9月', '10月', '11月', '12月'],
                            weekdays: ['日曜日', '月曜日', '火曜日', '水曜日', '木曜日', '金曜日', '土曜日'],
                            weekdaysShort: ['日', '月', '火', '水', '木', '金', '土'],
                            dateFieldFormat: 'YYYY年 MM月 DD日'
                        },
                        'en': {
                            previousMonth: 'Previous Month',
                            nextMonth: 'Next Month',
                            months: ['January', 'February', 'March', 'April', 'May', 'June', 'July', 'August', 'September', 'October', 'November', 'December'],
                            weekdays: ['Sunday', 'Monday', 'Tuesday', 'Wednesday', 'Thursday', 'Friday', 'Saturday'],
                            weekdaysShort: ['Sun', 'Mon', 'Tue', 'Wed', 'Thu', 'Fri', 'Sat'],
                            dateFieldFormat: 'YYYY / MM / DD'
                        },
                        'ko': {
                            previousMonth: '지난 달',
                            nextMonth: '다음 달',
                            months: ['일월', '이월', '삼월', '사월', '오월', '유월', '칠월', '팔월', '구월', '시월', '십일월', '십이월'],
                            weekdays: ['일요일', '월요일', '화요일', '수요일', '목요일', '금요일', '토요일'],
                            weekdaysShort: ['일', '월', '화', '수', '목', '금', '토'],
                            dateFieldFormat: 'YYYY년 MM월 DD일'
                        }
                    };
                    dateFieldFormat = pikaI18n[locale].dateFieldFormat;
                    checkInDate = new Pikaday({
                        format: dateFieldFormat,
                        field: document.getElementById('datepicker-check-in'),
                        trigger: document.getElementById('check-in-group'),
                        i18n: pikaI18n[locale],
                        keyboardInput: false,
                        disableDayFn: function disableDayFn(dateField) {
                            var d = new Date();
                            d.setDate(d.getDate() - 1);
                            if (dateField <= d) {
                                return true;
                            }
                        },
                        onSelect: function onSelect() {
                            var checkInDateObj = checkInDate.getDate();
                            var checkOutDateObj = checkOutDate.getDate();

                            //快速訂房-租車類別的還車日調整
                            if (hotelType === 'rentalcars') {
                                checkOutDate.setMinDate(new Date(checkInDateObj.getFullYear(), checkInDateObj.getMonth(), checkInDateObj.getDate()));
                                if (checkOutDateObj === null || checkOutDateObj < checkInDateObj) {
                                    checkOutDate.setDate(new Date(checkInDateObj.getFullYear(), checkInDateObj.getMonth(), checkInDateObj.getDate()));
                                    checkOutDate.show();
                                }
                            } else {
                                checkOutDate.setMinDate(new Date(checkInDateObj.getFullYear(), checkInDateObj.getMonth(), checkInDateObj.getDate() + 1));
                                if (checkOutDateObj === null || checkOutDateObj <= checkInDateObj) {
                                    checkOutDate.setDate(new Date(checkInDateObj.getFullYear(), checkInDateObj.getMonth(), checkInDateObj.getDate() + 1));
                                    checkOutDate.show();
                                }
                            }
                            document.getElementById('check-in-date').value = checkInDate.toString('YYYY-MM-DD');
                        }
                    });
                    checkOutDate = new Pikaday({
                        format: dateFieldFormat,
                        field: document.getElementById('datepicker-check-out'),
                        trigger: document.getElementById('check-out-group'),
                        i18n: pikaI18n[locale],
                        keyboardInput: false,
                        disableDayFn: function disableDayFn(dateField) {
                            var d = new Date();
                            if (dateField <= d) {
                                return true;
                            }
                        },
                        onSelect: function onSelect() {
                            document.getElementById('check-out-date').value = checkOutDate.toString('YYYY-MM-DD');
                        }
                    });


                    $('#fast-booking-form-submit').bind('click', function (event) {
                        event.preventDefault();
                        var checkInDateInput = $('#datepicker-check-in').val();
                        var checkOutDateInput = $('#datepicker-check-out').val();

                        if (checkInDateInput.length <= 0) {
                            alert(text.SystemText.SelectDate);
                            checkInDate.show();
                            return false;
                        }
                        if (checkOutDateInput.length <= 0) {
                            alert(text.SystemText.SelectDate);
                            checkOutDate.show();
                            return false;
                        }
                        if (!$.isNumeric($('select[name="roomcount"]').val())) {
                            alert(text.SystemText.SelectQuantity);
                            return false;
                        }
                        if (new Date(checkOutDate) < new Date(checkInDate)) {
                            alert(text.SystemText.GreaterThan);
                            return false;
                        }

                        //快速訂房-租車類別的送出的還車日調整
                        if (hotelType === 'rentalcars') {
                            var checkOutDateObj = checkOutDate.getDate();
                            checkOutDate.setDate(new Date(checkOutDateObj.getFullYear(), checkOutDateObj.getMonth(), checkOutDateObj.getDate() + 1));
                        }

                        $('#fast-booking-form').submit();
                    });

                    //對使用者輸入的promo code進行檢查
                    $('#promo-code-text').attr({
                        'data-parsley-required': true,
                        'data-parsley-pattern': '[A-Za-z0-9]+',
                        'data-parsley-pattern-message': '僅可英文數字組合'
                    });

                    validator = parsley.$element.find('#promo-code-form').parsley({
                        errorsWrapper: '<div></div>',
                        errorTemplate: '<span class="color-red" style="font-size: 10pt; color: #e74c3c;"></span>',
                        errorsContainer: function errorsContainer(field) {
                            return field.$element.closest('div').find('div.error-message');
                        }
                    });


                    $('#promo-code-form-submit').bind('click', function (event) {
                        validator.validate();
                        if (validator.isValid()) {
                            $('#promo-code-form').submit();
                        }
                    });

                    if ($('#datepicker-check-in').val().length !== 0 && $('#check-in-date').val().length <= 0) {
                        document.getElementById('datepicker-check-in').value = '';
                        document.getElementById('datepicker-check-out').value = '';
                        $("#roomcount").val(1);
                    }

                    $(document).ready(function () {
                        $('#autoNotice').get(0).click();
                    });

                    $('#Notice-remember').on('change', function () {
                        $.ajax(urlPrefix + '/api/index/notice', {
                            type: 'post',
                            headers: {
                                "X-CSRF-TOKEN": $('meta[name="csrf-token"]').attr('content')
                            }
                        });
                    });

                case 20:
                case 'end':
                    return _context2.stop();
            }
        }
    }, _callee2, this);
})));
/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(1)))

/***/ }),

/***/ 493:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 5:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 500:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),

/***/ 6:
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ })

},[268]);


// WEBPACK FOOTER //
// js/build/index-55fb15e5827d0458f059.js